import { viewportCategoryToColumnCount } from "../../../../state/modules/layout/columnCount";
import { COLUMN_COUNT_TO_PROMO_TILE_POSITION } from "./config";

const getPromoTilePosition = ({ viewportCategory }) => {
  const columnCount = viewportCategoryToColumnCount(viewportCategory);

  return COLUMN_COUNT_TO_PROMO_TILE_POSITION[columnCount] - 1;
};

export default getPromoTilePosition;
